import React from "react";

import ProfileContainer from "../../rows/ProfileContainer";
import ChangePassword from "../../molecules/ChangePassword";

const ChangePasswordPage = () => (
  <ProfileContainer type="profile" hideTopAd={true}>
    <ChangePassword />
  </ProfileContainer>
);

export { ChangePasswordPage };
